import MetaIntegrationForm from "./IntegrationForms/MetaIntegrationForm.jsx";
import MySQLLeadIntegrationForm from "./IntegrationForms/MySQLLeadIntegrationForm.jsx";
import {useErrorTranslation} from "../../../api/utilities/translateErrorMessage.js";
import {useEffect, useState} from "react";
import GoogleIntegrationForm from "./IntegrationForms/GoogleIntegrationForm.jsx";
import BsShopIntegrationForm from "./IntegrationForms/BsShopIntegrationForm.jsx";
import ShoptetIntegrationForm from "./IntegrationForms/ShoptetIntegrationForm.jsx";
import SklikIntegrationForm from "./IntegrationForms/SklikIntegrationForm.jsx";
import HeurekaIntegrationForm from "./IntegrationForms/HeurekaIntegrationForm.jsx";
import UpgatesIntegrationForm from "./IntegrationForms/UpgatesIntegrationForm.jsx";
import {isPreview} from "../../../utils/environment.js";
import PageTitle from "../../../components/PageTitle.jsx";
import {useTranslation} from "react-i18next";
import GlamiIntegrationForm from "./IntegrationForms/GlamiIntegrationForm.jsx";
import ZboziIntegrationForm from "./IntegrationForms/ZboziIntegrationForm.jsx";
import MicrosoftIntegrationForm from "./IntegrationForms/MicrosoftIntegrationForm.jsx";

export default function ThirdPartyServiceEditForm({project, brand, projectIntegration}) {

    let {t} = useTranslation();
    let {et} = useErrorTranslation();

    let [errCount, setErrCount] = useState({});
    let [translatedErrors, setTranslatedErrors] = useState({});

    const forms = {
        meta: <MetaIntegrationForm project={project} projectIntegration={projectIntegration}/>,
        mysql: <MySQLLeadIntegrationForm project={project} projectIntegration={projectIntegration}/>,
        google: <GoogleIntegrationForm project={project} projectIntegration={projectIntegration}/>,
        microsoft: <MicrosoftIntegrationForm project={project} projectIntegration={projectIntegration}/>,
        sklik: <SklikIntegrationForm project={project} projectIntegration={projectIntegration}/>,
        zbozi: <ZboziIntegrationForm project={project} projectIntegration={projectIntegration}/>,
        glami: <GlamiIntegrationForm project={project} projectIntegration={projectIntegration}/>,
        heureka: <HeurekaIntegrationForm project={project} projectIntegration={projectIntegration}/>,
        bsshop: <BsShopIntegrationForm project={project} projectIntegration={projectIntegration}/>,
        shoptet: <ShoptetIntegrationForm project={project} projectIntegration={projectIntegration}/>,
        upgates: <UpgatesIntegrationForm project={project} projectIntegration={projectIntegration}/>,
    };

    const form = forms[brand.slug] || null;

    useEffect(() => {
        setTranslatedErrors({});
        if (projectIntegration && projectIntegration.errors) {
            for (let error of projectIntegration.errors) {
                et(error).then((message) => {
                    setTranslatedErrors((translatedErrors) => {
                        translatedErrors[JSON.stringify(message)] = message;
                        setErrCount(errCount + 1);
                        return translatedErrors;
                    });
                });
            }
        }

    }, [projectIntegration?.errors]);

    if (isPreview()) {
        return <PageTitle>{t('error.endpoint-not-allowed-on-demo')}</PageTitle>;
    }

    return (<div>
        {projectIntegration && <div className={'form-input mb-4'}>Integration Id: <i>{projectIntegration.id}</i></div>}
        {Object.values(translatedErrors).map((error, key) => {
            return <div key={'error-' + key} className={'bg-red-300 text-red-800 rounded my-3 py-2 px-4'}>{error}</div>;
        })}
        {form}
    </div>);
}